import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useGTMTracking = () => {
  const location = useLocation();
  const prevPathRef = useRef<string>("");

  useEffect(() => {
    // Only track if the path has changed
    if (prevPathRef.current === location.pathname) return;

    // Update the previous path
    prevPathRef.current = location.pathname;

    // Normalize the path and determine category
    let normalizedPath = location.pathname;
    let pageCategory = "";

    // Trackers page
    if (/^\/trackers\/\d+/.test(normalizedPath)) {
      normalizedPath = "/trackers";
      pageCategory = "trackers";
    }

    //Add tracker page
    else if (/^\/add-tracker\/\d+/.test(normalizedPath)) {
      normalizedPath = "/add-tracker";
      pageCategory = "add_tracker";
    }

    // Previous online commands page
    else if (/^\/trackers\/settings\/.*/.test(normalizedPath)) {
      normalizedPath = "/trackers/settings";
      pageCategory = "previous_online_commands";
    }
    // Online commands page
    else if (/^\/online-commands\/\d+/.test(normalizedPath)) {
      normalizedPath = "/online-commands";
      pageCategory = "online_commands";
    }

    //Other alerts page
    else if (/^\/other-alerts\/\d+/.test(normalizedPath)) {
      normalizedPath = "/other-alerts";
      pageCategory = "other_alerts";
    }

    //Other settings page
    else if (/^\/other-settings\/\d+/.test(normalizedPath)) {
      normalizedPath = "/other-settings";
      pageCategory = "other_settings";
    }

    //Notification page
    else if (/^\/notification\/\d+/.test(normalizedPath)) {
      normalizedPath = "/notification";
      pageCategory = "notification";
    }

    //Chat page
    else if (/^\/notification\/chat\/.*/.test(normalizedPath)) {
      normalizedPath = "/notification/chat";
      pageCategory = "tracker_chat";
    }

    //Transactions page
    else if (/^\/transactions\/\d+/.test(normalizedPath)) {
      normalizedPath = "/transactions";
      pageCategory = "transactions";
    }

    //Factor page
    else if (/^\/transactions\/factor\/.*/.test(normalizedPath)) {
      normalizedPath = "/transaction/factor";
      pageCategory = "factor";
    }

    //Plans page
    else if (/^\/plans\/\d+/.test(normalizedPath)) {
      normalizedPath = "/plans";
      pageCategory = "plans";
    }

    //App settings page
    else if (/^\/settings\/\d+/.test(normalizedPath)) {
      normalizedPath = "/app-settings";
      pageCategory = "app_settings";
    }

    //Login page
    else if (/^\/auth\/\d+/.test(normalizedPath)) {
      normalizedPath = "/login";
      pageCategory = "login";
    }

    //signup page
    else if (/^\/auth\/signup\/.*/.test(normalizedPath)) {
      normalizedPath = "/signup";
      pageCategory = "signup";
    }

    //Forget password page
    else if (/^\/auth\/login-forget-password\/.*/.test(normalizedPath)) {
      normalizedPath = "/forget-password";
      pageCategory = "forget_password";
    }

    //Verify page
    else if (/^\/auth\/verify\/.*/.test(normalizedPath)) {
      normalizedPath = "/verify";
      pageCategory = "verify";
    }

    // For other pages, use the path as category
    else {
      pageCategory = normalizedPath.replace(/^\//, "").replace(/\//g, "_");
    }

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: normalizedPath,
      page_title: document.title,
      page_location: window.location.href.replace(
        location.pathname,
        normalizedPath,
      ),
      page_category: pageCategory,
    });
  }, [location]);
};

export default useGTMTracking;
